import { Badge } from "@babackapp/customer-ui/components/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/customer-ui/components/tooltip";
import { CrownIcon, InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AdminBadge() {
  const { t } = useTranslation("return-widget-v3");
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge className="z-10 cursor-help bg-admin text-admin-foreground border-admin-border absolute -translate-y-1/2 top-0 left-0 right-0 mx-auto">
          <CrownIcon /> {t("adminBadge.label")} <InfoIcon />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{t("adminBadge.tooltip")}</TooltipContent>
    </Tooltip>
  );
}
